<template>
  <div class="start">

    <video-dialog
      hash="#comedy-roast"
      poster="https://d3ivhmcqxvlmhm.cloudfront.net/group-video-template/c02e39f8-92ab-42de-8cb9-71bf0bce37b5/poster_6cafbc3d-9a94-40da-9998-eb1b318d51f1.jpg"
      src="https://d3ivhmcqxvlmhm.cloudfront.net/group-video/b9721877-fed3-440c-880d-fe471cb443ff/r/17bdbfdf-13a2-4ee6-a62a-ee1254be890e.mp4"
    />

    <video-dialog
      hash="#romantic-slideshow"
      poster="https://cdn.ellacard.com/group-video-template/6dfc737b-eb5e-489d-9f19-337ca518e065/poster_4bec968d-f832-4494-a0c0-8997f03eca86.jpg"
      src="https://cdn.ellacard.com/group-video/5f37640d-50e4-4a18-8cee-9ce5e392cf90/r/252115d5-96d1-4e2a-ac7e-99033fb086ed.mp4"
    />

    <video-dialog
      hash="#memorial-eulogy"
      poster="https://d3ivhmcqxvlmhm.cloudfront.net/group-video-template/56007696-095a-45dc-aacf-8f6994bcc87a/poster_912bb482-8790-49dd-b943-0ed2f0ac91b9.jpg"
      src="https://cdn.ellacard.com/group-video/6e1c2680-84a8-4bdb-b923-ad6a3f3ce485/r/bea8dcd6-2bc6-4623-94e0-e73f3bf2937c.mp4"
    />

    <video-dialog
      hash="#graduation"
      poster="https://d3ivhmcqxvlmhm.cloudfront.net/group-video-template/49a43bad-9ecf-423f-8929-0b8ff6532745/poster_f87c459b-c259-4361-b3e5-67ed55edd3b7.jpg"
      src="https://d3ivhmcqxvlmhm.cloudfront.net/group-video/d2b7371d-def7-40f6-ab3e-aebc5fbcdce9/r/91e754a6-f0e5-4e48-a0a8-b4490e8e45be.mp4"
    />

    <start-header
      :media="{ id: 'e4ccfbb2-ae92-4e43-8238-47252dca0856', alt: 'Video maker example', video: true }"
      :bg="{ src: 'https://cdn.ellacard.com/page_backgrounds/Comic Book.mp4', color: '#f8d96d' }"
      :to="{ name: 'catalog-video' }"
    >
      <template v-slot:h1>Make an instant <i>group</i> video for any occasion</template>
      <template v-slot:h2>Pick a theme, add photos and videos, invite friends / family to add, and it all works instantly in your browser</template>
    </start-header>

    <start-layer clip-waves-class="light-gradient" :offset=".75">

      <div class="actions">
        <v-btn class="btn-pop" x-large rounded dark color="ec-blue" :to="{ name: 'catalog-video' }">Start a video <v-icon class="mr-n1" v-html="mdiChevronRight" /></v-btn>
      </div>

      <div class="grid-alternate">

        <web-media
          class="d-block hover-pop rounded black"
          aspect-ratio="16 / 9"
          id="02e6cdb6-c332-4839-a74d-32e3944f7722" alt="Example comedy night roast preview" is-video
          title="Example comedy night roast"
          :to="{ hash: '#comedy-roast' }"
        />

        <div>
          <h4 class="mb-3">A comedy roast for your dad's big birthday</h4>
          <div class="mb-3">Invite all your relatives to contribute, no matter where they live</div>
          <div class="ma-n2">
            <v-btn class="btn-pop ma-2" rounded dark color="ec-blue" title="Example comedy night roast" :to="{ hash: '#comedy-roast' }">
              <v-icon class="mr-2" v-html="mdiVideoVintage" /> Demo…
            </v-btn>
            <v-btn class="btn-pop ma-2" rounded dark color="ec-blue" :to="{ name: 'video-template', params: { templateId: '3050426e-f102-4978-af9c-9b67eb2f4b0f' } }">Make this video <v-icon class="mr-n1" v-html="mdiChevronRight" /></v-btn>
          </div>
        </div>

        <web-media
          class="d-block hover-pop rounded black"
          aspect-ratio="16 / 9"
          id="db90bfa0-ed03-471b-b4b5-8c3b5299dd7e" alt="Example anniversary slideshow preview" is-video
          title="Example anniversary slideshow"
          :to="{ hash: '#romantic-slideshow' }"
        />

        <div>
          <h4 class="mb-3">A romantic slideshow for your anniversary</h4>
          <div class="mb-3">
            Make a cute, romantic slideshow with upbeat music to remind your significant other how you feel. Include your own photos and video messages.
          </div>
          <div class="ma-n2">
            <v-btn class="btn-pop ma-2" rounded dark color="ec-blue" title="Example anniversary slideshow" :to="{ hash: '#romantic-slideshow' }">
              <v-icon class="mr-2" v-html="mdiVideoVintage" /> Demo…
            </v-btn>
            <v-btn class="btn-pop ma-2" rounded dark color="ec-blue" :to="{ name: 'video-template', params: { templateId: '6dfc737b-eb5e-489d-9f19-337ca518e065' } }">Make this video <v-icon class="mr-n1" v-html="mdiChevronRight" /></v-btn>
          </div>
        </div>

        <web-media
          class="d-block hover-pop rounded black"
          aspect-ratio="16 / 9"
          id="42f85eb0-f87a-412e-b6bf-72f1a28033c0" alt="Example eulogy slideshow preview" is-video
          title="Example eulogy slideshow"
          :to="{ hash: '#memorial-eulogy' }"
        />

        <div>
          <h4 class="mb-3">A touching memorial eulogy</h4>
          <div class="mb-3">Add photos and record video messages to celebrate the life of someone important to you</div>
          <div class="ma-n2">
            <v-btn class="btn-pop ma-2" rounded dark color="ec-blue" title="Example eulogy slideshow" :to="{ hash: '#memorial-eulogy' }">
              <v-icon class="mr-2" v-html="mdiVideoVintage" /> Demo…
            </v-btn>
            <v-btn class="btn-pop ma-2" rounded dark color="ec-blue" :to="{ name: 'video-template', params: { templateId: '56007696-095a-45dc-aacf-8f6994bcc87a' } }">Make this video <v-icon class="mr-n1" v-html="mdiChevronRight" /></v-btn>
          </div>
        </div>

        <web-media
          class="d-block hover-pop rounded black"
          aspect-ratio="16 / 9"
          id="1ade447b-e095-4f82-9c71-4ca28fd9f026" alt="Example graduation video preview" is-video
          title="Example graduation celebration"
          :to="{ hash: '#graduation' }"
        />

        <div>
          <h4 class="mb-3">A graduation celebration</h4>
          <div class="mb-6">
            Congratulate your new grad with photos and video messages from everyone they know, all arranged automatically with exciting effects
          </div>
          <div class="ma-n2">
            <v-btn class="btn-pop ma-2" rounded dark color="ec-blue" title="Example graduation celebration" :to="{ hash: '#graduation' }">
              <v-icon class="mr-2" v-html="mdiVideoVintage" /> Demo…
            </v-btn>
            <v-btn class="btn-pop ma-2" rounded dark color="ec-blue" :to="{ name: 'video-template', params: { templateId: '736ff318-f768-4339-a84a-d0382ec62a34' } }">Make this video <v-icon class="mr-n1" v-html="mdiChevronRight" /></v-btn>
          </div>
        </div>

      </div>

      <div class="actions">
        <v-btn class="btn-pop" x-large rounded dark color="ec-blue" :to="{ name: 'catalog-video' }">
          Start a video
          <v-icon class="mr-n1" v-html="mdiChevronRight" />
        </v-btn>
      </div>

    </start-layer>

    <start-layer clip-waves-class="gold-gradient" :offset=".9">
      <div class="grid-alternate">

        <web-media
          class="hover-pop rounded black"
          aspect-ratio="16 / 9"
          id="60669790-049f-4204-8c73-eec10d65dc5d"
          alt="Example of opening a standalone video"
          is-video
        />

        <div>
          <h4>Send your video as an Ellacard for the perfect presentation</h4>
          <!--
          <div class="text-md-h6 mb-6"></div>
          <div class="ma-n2">
            <v-btn class="btn-pop ma-2" rounded dark color="ec-blue">Try demo…</v-btn>
          </div>
          -->
        </div>

        <div class="relative hover-pop-group" style="aspect-ratio: 1.65;">
          <web-media
            class="absolute rounded black"
            style="width: 94%; top: 0; left: 3%;"
            aspect-ratio="16 / 9"
            id="1ade447b-e095-4f82-9c71-4ca28fd9f026" alt="Example graduation video preview" is-video
          />
          <v-btn
            v-for="[ icon, title, color ], i in SHARE_ICONS" :key="i"
            style="bottom: 0; width: 12%; height: unset; aspect-ratio: 1;"
            v-bind:style="{ left: (123 * i / 7) + '%' }"
            absolute fab
          >
            <v-icon large :color="color" v-html="icon" />
            <span class="btn-tooltip bottom">{{title}}</span>
          </v-btn>
        </div>

        <div>
          <h4>Or download / share your video on YouTube, Facebook, etc.</h4>
          <!-- <div class="text-md-h6 mb-3">It may take a few hours to build your video depending on its length</div> -->
        </div>

      </div>
    </start-layer>

    <start-layer clip-waves-class="green-creative-supplies" :offset=".9">
      <h2 class="mb-16 text-center">Custom video templates</h2>
      <h4 class="mt-16 mx-auto text-center">Have a use case that's not addressed by one of our <router-link :to="{ name: 'catalog-video' }">existing video templates</router-link>? We make custom video templates for any project. Price varies based on complexity; contact us for more details: <a href="mailto:contact@ellacard.com">contact@ellacard.com</a></h4>
    </start-layer>

    <start-layer clip-waves-class="dark-gradient" :offset=".5">
      <h2>For business</h2>

      <div class="grid-alternate">

        <web-media
          class="d-block hover-pop rounded black"
          aspect-ratio="16 / 9"
          id="66aea453-adf2-4be5-a64d-8a58a83c1b01" alt="Example corporate holiday group video" is-video
          title="Enhance workplace culture with a personalized holiday video from leadership"
          :to="{ name: 'blog-post', params: { urlTitle: 'enhance-workplace-culture-with-a-personalized-holiday-video-from-leadership' } }"
        />

        <div>
          <h4 class="mb-3">A group holiday video from leadership</h4>
          <div class="mb-6">
            Executives with busy schedules are hard to get a hold of. Learn how companies use annual holiday videos from leadership to strengthen their connection with employees and foster a sense of unity across the organization.
          </div>
          <div class="ma-n2">
            <v-btn class="btn-pop ma-2" rounded dark color="ec-blue" title="Enhance workplace culture with a personalized holiday video from leadership" :to="{ name: 'blog-post', params: { urlTitle: 'enhance-workplace-culture-with-a-personalized-holiday-video-from-leadership' } }">Read blog post <v-icon class="mr-n1" v-html="mdiChevronRight" /></v-btn>
          </div>
        </div>

        <web-media
          class="d-block hover-pop rounded black"
          aspect-ratio="16 / 9"
          id="880e1d35-b7e5-4723-b2ed-9e3bafcc63c2" alt="Example candidate offer video" is-video
          title="Why job offer videos are the secret weapon for competitive hiring"
          :to="{ name: 'blog-post', params: { urlTitle: 'why-job-offer-videos-are-the-secret-weapon-for-competitive-hiring' } }"
        />

        <div>
          <h4 class="mb-3">Extend compelling offers to interview candidates</h4>
          <div class="mb-6">
            Top candidates have their choice of jobs. Learn how companies are using Ellacard's video maker to share their team's excitement with candidates in the form of branded custom job-offer videos.
          </div>
          <div class="ma-n2">
            <v-btn class="btn-pop ma-2" rounded dark color="ec-blue" title="Why job offer videos are the secret weapon for competitive hiring" :to="{ name: 'blog-post', params: { urlTitle: 'why-job-offer-videos-are-the-secret-weapon-for-competitive-hiring' } }">Read blog post <v-icon class="mr-n1" v-html="mdiChevronRight" /></v-btn>
          </div>
        </div>

      </div>

      <!--
      <v-container class="pb-16" fluid>
        <h3 class="mt-6 mb-12 text-h6 text-md-h5 header-font font-weight-bold text-center text-md-left">
          Look <i>good</i> with Ellacard. We want to help you send high quality emails for a gorgeous recipient experience, whether those emails point to a card, a video, or use your own custom layout.
        </h3>
      </v-container>
      -->

    </start-layer>

    <start-reviews tag="VI" />

    <start-footer />

  </div>
</template>


<script>
import ClipWaves from '@/components/ClipWaves.vue';
import OrgSignUpDialog from '@/components/OrgSignUpDialog.vue';
import OutlineLaptop from '@/components/OutlineLaptop.vue';
import OutlinePhone from '@/components/OutlinePhone.vue';
import SendSampleDialog from '@/components/SendSampleDialog.vue';
import StartFooter from '@/components/StartFooter.vue';
import StartHeader from '@/components/StartHeader.vue';
import StartLayer from '@/components/StartLayer.vue';
import StartReviews from '@/components/StartReviews.vue';
import VideoDialog from '@/components/VideoDialog.vue';
import WebMedia from '@/components/WebMedia.vue';
import iconPathX from 'raw-loader!@/assets/icon-path-x.txt';
import { mdiPencil, mdiImageMultiple, mdiHomeCity, mdiCalendar, mdiWalletGiftcard, mdiChevronRight, mdiPlay, mdiVideoVintage, mdiDownload, mdiYoutube, mdiInstagram, mdiTwitter, mdiFacebook, mdiLinkedin } from '@mdi/js';


const HOLIDAY_RED = 'rgb(192,41,50)';

const SAMPLE_ORDER_ID = 'fc2726e8-5e18-4ebb-8444-32eef3397380';

const SHARE_ICONS = [
  [ mdiDownload, 'Download' ],
  [ mdiYoutube, 'YouTube', '#FF0000' ],
  [ mdiInstagram, 'Instagram', '#000' ],
  [ iconPathX, 'X', '#000' ],
  [ mdiFacebook, 'Facebook', '#1877f2' ],
  [ mdiLinkedin, 'LinkedIn', '#007bb5' ]
];

export default {
  name: 'start-video-maker',

  routerViewMeta: {
    $class: 'fade-transparent',
    $subtitle: 'Video maker',
    description: "Make an instant (group) video for any occasion. Pick a theme, add photos and videos, invite friends / family to add, and it all works instantly in your browser."
  },

  components: {
    ClipWaves,
    OrgSignUpDialog,
    OutlineLaptop,
    OutlinePhone,
    SendSampleDialog,
    StartFooter,
    StartHeader,
    StartLayer,
    StartReviews,
    VideoDialog,
    WebMedia
  },

  data() {
    return {
      sample: null,
      showSendSample: false
    }
  },

  created() {
    Object.assign(this, { SHARE_ICONS, HOLIDAY_RED, mdiPencil, mdiImageMultiple, mdiHomeCity, mdiCalendar, mdiWalletGiftcard, mdiChevronRight, mdiPlay, mdiVideoVintage });
  },

  watch: {
    '$route.hash': {
      immediate: true,
      async handler(v) {
        if (v?.startsWith('#demo:') && !this.sample)
          this.sample = await this.$call('get-order', { order_id: SAMPLE_ORDER_ID });
      }
    }
  }
}
</script>
